:host {
  display: block;
  width: 100%;
}

.table {
  display: flex;
  flex-direction: column;
  width: 100%;

  font-size: var(--body-size);
  font-weight: 400;
  line-height: var(--body-size);
  color: var(--body-text-arrows-400);
}

.row {
  display: flex;
  gap: calc(var(--spacer) * 2);
  align-items: center;
  width: 100%;
  height: auto;
  min-height: 32px;

  border-bottom: 1px solid var(--chart-101-pressed-dividers);

  // Mandatory for hover to work on the empty spaces between columns
  background-color: transparent;

  pointer-events: auto;
}

.cell {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
}

:host([rowsClickable]) {
  .row {
    cursor: pointer;
  }

  .row:hover .cell > *::part(highlightable),
  .row:hover .cell *::part(highlightable) {
    // Support highlighting for any interior component exposing some text
    color: var(--blue-layout-400-primary);
    // Support highlighting for any interior SVG icon
    fill: var(--blue-layout-400-primary);
  }
}

:host([cellsClickable]) {
  .cell {
    cursor: pointer;
  }

  .cell:hover > *::part(highlightable),
  .cell:hover *::part(highlightable) {
    // Support highlighting for any interior component exposing some text
    color: var(--blue-layout-400-primary);
    // Support highlighting for any interior SVG icon
    fill: var(--blue-layout-400-primary);
  }
}

:host([alignLastColumnRight]) .row .cell:last-child {
  justify-content: flex-end;
  text-align: right;
}
